/* eslint-disable react/prop-types */
import React from 'react';

const Upload = ({ fill = 'var(--SECONDARY_DARK)' }) => (
  <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
    <g fill={fill} fillRule="nonzero">
      <path d="M10.053 3.45V0H1.926A1.935 1.935 0 000 1.92v16.16C0 19.131.873 20 1.926 20h11.598a1.935 1.935 0 001.926-1.92V5.66h-3.18a2.212 2.212 0 01-2.217-2.211zM4.317 9.9l3.101-3.328a.432.432 0 01.624 0l3.1 3.327c.16.17.149.44-.02.598a.423.423 0 01-.286.112.45.45 0 01-.312-.133l-2.376-2.54v6.048c0 .233-.19.423-.423.423a.424.424 0 01-.423-.423V7.937l-2.365 2.54a.425.425 0 01-.598.02.425.425 0 01-.022-.598zm8.186 6.872c0 .233-.19.424-.424.424H3.37a.424.424 0 01-.423-.424c0-.232.19-.423.423-.423h8.715a.42.42 0 01.418.423z" />
      <path d="M12.27 4.815h2.598L10.9.65V3.45c0 .756.608 1.365 1.37 1.365z" />
    </g>
  </svg>
);

export default Upload;
